/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Cancel_Download_QuestionInputs */

const en_mobile_cancel_download_question = /** @type {(inputs: Mobile_Cancel_Download_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel this download?`)
};

const es_mobile_cancel_download_question = /** @type {(inputs: Mobile_Cancel_Download_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cancelar esta descarga?`)
};

/**
* | output |
* | --- |
* | "Cancel this download?" |
*
* @param {Mobile_Cancel_Download_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_cancel_download_question = /** @type {((inputs?: Mobile_Cancel_Download_QuestionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Cancel_Download_QuestionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_cancel_download_question(inputs)
	return en_mobile_cancel_download_question(inputs)
});